import { Icon } from "@iconify/react/dist/iconify.js";

const OrganizationCard = ({ 
    org, 
    currentOrgId, 
    showForm, 
    orgMembers, 
    onOrgClick 
}) => {
    return (
        <div
            className={`
                flex flex-col border border-border rounded-lg transition-all duration-200
                ${currentOrgId === org.id && showForm
                    ? 'bg-primary-20'
                    : 'interactive-card-container'
                }
            `}
        >
            {/* Header */}
            <div className="flex flex-row justify-between items-center p-4">
                <div className="flex flex-row gap-3 items-center flex-1" onClick={() => onOrgClick(org.id)}>
                    <Icon
                        icon={org.name === 'helios' ? "mdi:administrator-outline" : "octicon:organization-16"}
                        className={`text-2xl ${org.name === 'helios' ? 'text-primary' : 'text-accent'}`}
                    />
                    <div className="flex flex-col">
                        <p className="font-semibold text-lg">{org.display_name || org.name}</p>
                        <p className="text-sm text-font-secondary">{orgMembers[org.id]?.length || 0} members</p>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    <Icon
                        icon={currentOrgId === org.id && showForm ? "icon-park-solid:up-c" : "icon-park-outline:down-c"}
                        className={`text-xl ${org.name === 'helios' ? 'text-primary' : 'text-accent'}`}
                    />
                </div>
            </div>

            <hr className="border-bgAccent" />

            {/* Logo Section */}
            <div className="flex items-center justify-center p-4 min-h-[120px] bg-gray-800 bg-opacity-20 cursor-pointer" onClick={() => onOrgClick(org.id)}>
                {org.branding?.logo_url ? (
                    <img
                        src={org.branding.logo_url}
                        alt={org.name}
                        className="max-w-full max-h-[100px] object-contain"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />
                ) : null}
                <div className="flex items-center justify-center w-full h-full" style={{display: org.branding?.logo_url ? 'none' : 'flex'}}>
                    <Icon
                        icon={org.name === 'helios' ? "mdi:shield-crown" : "mdi:office-building"}
                        className={`text-6xl ${org.name === 'helios' ? 'text-primary' : 'text-accent'} opacity-50`}
                    />
                </div>
            </div>

            <hr className="border-bgAccent" />

            {/* Info Section */}
            <div className="flex flex-col gap-2 p-4 cursor-pointer" onClick={() => onOrgClick(org.id)}>
                <div className="flex flex-row items-center justify-between w-full gap-1">
                    <p className="text-xs text-font-secondary uppercase tracking-wide">Organization ID</p>
                    <p className="text-sm p-1.5 card-container rounded font-mono">{org.name}</p>
                </div>
                <hr className="border-bgAccent" />
                <div className="flex flex-row items-center justify-between w-full gap-1">
                    <p className="text-xs text-font-secondary uppercase tracking-wide">Default Role</p>
                    <p className="text-sm p-1.5 card-container rounded">
                        {org.name === 'helios' ? 'helios_admin' : 'client_admin'}
                    </p>
                </div>
                <hr className="border-bgAccent" />
                {org.metadata?.client_id && (
                    <div className="flex flex-row items-center justify-between w-full gap-1">
                        <p className="text-xs text-font-secondary uppercase tracking-wide">Client ID</p>
                        <p className="text-sm p-1.5 card-container rounded font-mono">{org.metadata.client_id}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OrganizationCard;
